import { Select } from "antd";
import { SelectComPesquisa } from "../../SelectComPesquisa";
import { useListar } from "../../../Services/Domain/Viagem/ViagemService";
import { useEffect, useMemo } from "react";
import { EnumStatusDaViagem } from "@/Models/Domain/Viagem/StatusDaViagem";

interface IViagemSelectProps extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {
    // onChange?:(value:TypeViagem|null) => void;
    // value?:TypeViagem|null;
    codsCentrosDeCusto?:number[];
    codSituacoesInvalidas?:EnumStatusDaViagem[];
    codViagemIgnorarFiltro?:number;
    selectAutomatico?:boolean;
    dataInicial?:Date;
    dataFinal?:Date;
}
export default function ViagemSelect({
    placeholder,
    codsCentrosDeCusto,
    codSituacoesInvalidas,
    codViagemIgnorarFiltro,
    dataInicial,
    dataFinal,
    selectAutomatico,
    onChange, 
    value,
    ...rest
}:IViagemSelectProps) {
    const {
        data,
        isLoading
    } = useListar({
        ativo : true,
        codsCentrosDeCusto : codsCentrosDeCusto,
        codSituacoesInvalidas : codSituacoesInvalidas,
        codViagemIgnorarFiltro : codViagemIgnorarFiltro,
        dataInicial : dataInicial,
        dataFinal : dataFinal
    });

    const options = useMemo(() => data?.map(m => {
        return {
            value : m.codigo,
            label : `${m.titulo} (${m.turma})`
        }
    }), [data]);

    useEffect(() => {
        if (selectAutomatico && value === undefined && options?.length === 1)
        {
            onChange?.(options[0].value, options[0]);
        }
    }, [selectAutomatico, options, value]);

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear
        loading={isLoading}
        options={options}
        onChange={onChange}
        value={value}
    />
}